import { Link } from "react-router-dom";
import { ArrowUpRight, User, LineChart, Briefcase, Building2, Mail, FileDown } from "lucide-react";
import { Reveal, SectionHead } from "@/components/motion";
import { CONTACT } from "@/data/projects";

const TILES = [
  { num: "01", title: "About Me", text: "From hotel operations to strategic hospitality analysis.", to: "/about", icon: User },
  { num: "02", title: "Expertise", text: "Investment, feasibility, commercial analytics and operations.", to: "/expertise", icon: LineChart },
  { num: "03", title: "Selected Work", text: "Four hospitality business questions explored through analysis.", to: "/work", icon: Briefcase },
  { num: "04", title: "Experience", text: "Hotel operations, education and professional development.", to: "/experience", icon: Building2 },
  { num: "05", title: "Contact", text: "Connect about hospitality opportunities.", to: "/contact", icon: Mail },
  { num: "06", title: "Download CV", text: "View my professional experience and project background.", href: CONTACT.cv, icon: FileDown },
];

const Tile = ({ t, i }) => {
  const Icon = t.icon;
  const inner = (
    <>
      <div className="flex items-start justify-between">
        <span className="text-[11px] font-semibold tracking-[0.2em] text-fog transition-colors duration-500 group-hover:text-moss">
          {t.num}
        </span>
        <ArrowUpRight
          size={16}
          strokeWidth={1.25}
          className="text-champagne transition-[transform,color] duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-moss"
          aria-hidden="true"
        />
      </div>
      <div className="mt-10">
        <Icon size={20} strokeWidth={1.25} className="text-fog transition-colors duration-500 group-hover:text-moss" aria-hidden="true" />
        <h3 className="mt-4 font-serif text-2xl sm:text-[1.7rem] font-light text-ink">{t.title}</h3>
        <p className="mt-2 text-sm leading-relaxed text-fog">{t.text}</p>
      </div>
    </>
  );
  const cls =
    "group flex h-full min-h-[210px] w-full flex-col justify-between border-b border-r border-hairline p-7 sm:p-8 text-left transition-[transform,background-color,border-color] duration-500 hover:-translate-y-0.5 hover:border-moss/30 hover:bg-stone2 focus-visible:-translate-y-0.5";
  const testid = `tile-${t.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;

  return (
    <Reveal delay={i * 0.06} y={20}>
      {t.to ? (
        <Link to={t.to} className={cls} data-testid={testid}>{inner}</Link>
      ) : (
        <a href={t.href} download className={cls} data-testid={testid}>{inner}</a>
      )}
    </Reveal>
  );
};

export default function ExploreTiles() {
  return (
    <section className="border-t border-hairline" data-testid="explore-portfolio">
      <div className="mx-auto max-w-[1400px] px-6 pb-16 pt-24 sm:px-10 sm:pb-20 sm:pt-32">
        <SectionHead
          label="Portfolio"
          title={<>Explore my <em className="text-moss">portfolio.</em></>}
          sub="Choose an area to explore."
        />
        <div className="grid grid-cols-1 border-l border-t border-hairline sm:grid-cols-2 lg:grid-cols-3">
          {TILES.map((t, i) => (
            <Tile key={t.num} t={t} i={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
